// extracted by mini-css-extract-plugin
export default {"main":"_68afde1b3b _1e065af045","xmark":"_1cb273cd1b","fl_img":"_12e97860f9 f54b97c842"};